RivalIQ.apps.Admin.module('models', function (models, Admin, Backbone, Marionette, $, _) {

    'use strict';

    models.CustomerChangeRequest = Backbone.Model.extend({
        initialize: function (data, options) {
            const me = this;
            me.url = `/admin/api/companies/${options.companyId}/customerChangeRequests`;
        },

        toJSON: function () {
            const me = this;
            const custom = {};
            if (me.has('needs_review_flags_suggestion')) {
                custom.name = RivalIQ.utils.needsReview.convertBitFieldToNameList(me.get('needs_review_flags_suggestion'))[0];
            }

            return _.extend({}, me.attributes, custom);
        }
    });
});
